/* eslint-disable */
import BACKGROUND_MAP from '@Brand/backgrounds/world-map.svg';
import CYBERHAWK_LOGO_BOTTOM from '@Brand/cyberhawk-logo-bottom.svg';
import CYBERHAWK_LOGO_TOP from '@Brand/cyberhawk-logo-top.png';
import CYBERHAWK_LOGO_TEXT from '@Brand/cyberhawk-text-bottom.svg';
import LOGO_ROUND from '@Brand/logo-round.svg';
import LOGO_ROUND_CLEAN from '@Brand/logo-round-clean.svg';
import LOGO_WHITE from '@Brand/logo-white.svg';
import LOGO_WHITE_TRANSPARENT from '@Brand/logo-white-transparent.svg';
import LOGO_WHITE_TRANSPARENT_NEW from '@Brand/logo-white-transparent-new.svg';
import LOGO_WHITE_WITH_BY_CYBERHAWK from '@Brand/logo-white-by-cyberhawk.svg';

const BRAND = process.env.REACT_APP_BRAND || 'ihawk';
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'iHAWK';
const BRAND_PAGE_TITLE = process.env.REACT_APP_PAGE_TITLE_PREFIX || 'iHAWK';

export {
    BACKGROUND_MAP,
    BRAND,
    BRAND_NAME,
    BRAND_PAGE_TITLE,
    CYBERHAWK_LOGO_BOTTOM,
    CYBERHAWK_LOGO_TEXT,
    CYBERHAWK_LOGO_TOP,
    LOGO_ROUND,
    LOGO_ROUND_CLEAN,
    LOGO_WHITE,
    LOGO_WHITE_TRANSPARENT,
    LOGO_WHITE_TRANSPARENT_NEW,
    LOGO_WHITE_WITH_BY_CYBERHAWK,
};
